// In-house ring sizing rules (single-SKU rings only — rings with size
// variants are bought as the variant instead).
// $25 covers up to two full sizes up OR any downsize; +$15 per additional
// half/full size past two up. Offered range: 4–12 in half steps; outside
// that range customers must contact us for a custom quote.

export const RING_SIZE_MIN = 4;
export const RING_SIZE_MAX = 12;

export const RING_SIZES = Array.from(
  { length: (RING_SIZE_MAX - RING_SIZE_MIN) * 2 + 1 },
  (_, i) => RING_SIZE_MIN + i / 2
);

export const sizingFee = (target, stock) => {
  const d = target - stock;
  if (d === 0) return 0;
  if (d < 0) return 25;
  if (d <= 2) return 25;
  return 25 + 15 * Math.ceil(d - 2);
};

// Stock size: the listed size when known, else the standard starting size
// (women's 7 / men's 10).
export const stockSizeOf = (product) => {
  const v = parseFloat(product?.variant_value);
  if (!Number.isNaN(v) && v > 0) return v;
  return product?.gender === "Men" ? 10 : 7;
};

export const prettySize = (n) => (Number.isInteger(n) ? String(n) : n.toFixed(1));
